import Service from './Service'
import { RESEARCHES } from './apiUrls'

export default class ContactService extends Service {
  getExport (query) {
    return this.axios.get('contacts-export', {params: query})
  }
  getResearches (query) {
    return this.axios.get(RESEARCHES, {params: query})
  }
  getResearchesById (id) {
    return this.axios.get(`${RESEARCHES}/${id}`)
  }
  postResearches (data) {
    return this.axios.post(RESEARCHES, data)
  }
  deleteResearches (id) {
    return this.axios.delete(`${RESEARCHES}/${id}`)
  }
}



// WEBPACK FOOTER //
// ./src/services/api/ContactService.js